import { render, staticRenderFns } from "./clientes.vue?vue&type=template&id=738fcab0&scoped=true&"
import script from "./clientes.vue?vue&type=script&lang=js&"
export * from "./clientes.vue?vue&type=script&lang=js&"
import style0 from "./clientes.vue?vue&type=style&index=0&id=738fcab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738fcab0",
  null
  
)

export default component.exports